import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { SUPPORT_EMAIL, SUPPORT_MAILTO } from "@/config/support";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted">
      <div className="text-center">
        <h1 className="mb-4 text-4xl font-bold">404</h1>
        <p className="mb-4 text-xl text-muted-foreground">Oops! Page not found</p>
        <a href="/" className="text-primary underline hover:text-primary/90">
          Return to Home
        </a>
        <p className="mt-8 text-xs text-muted-foreground">
          Need help?{" "}
          <a href={SUPPORT_MAILTO} className="underline">
            {SUPPORT_EMAIL}
          </a>
        </p>
      </div>
    </div>
  );
};

export default NotFound;
